







































import Vue from 'vue'
import LeftSidebarLayout from '@/components/LeftSidebarLayout'
import { KeyDict } from '@/types'
import { TranscodingRegion, WRTCServer, IOSSettings } from '@/types/admin'
import SubscribeAdminProperties from '@/mixins/SubscribeAdminProperties'
import SubscribeWowzaStats from '@/mixins/SubscribeWowzaStats'
import RegionSummary from '@/components/RegionSummary'
import WRTCServerSummary from '@/components/RegionSummary/WRTCServerSummary'
import './WRTCOverview.scss'
import { WowzaStat } from '@/types/wowza'
import { CheckboxButton, Button } from 'element-ui'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import GlobalAcceleratorOverview from '@/components/RegionSummary/GlobalAcceleratorOverview'

export default Vue.extend({
  name: 'WRTCOverview',
  mixins: [SubscribeAdminProperties, SubscribeWowzaStats],
  computed: {
    canDoOps (): boolean {
      return this.$can(AbilityAction.Do, AbilitySubject.Ops)
    },
    regions (): KeyDict<TranscodingRegion> {
      return this.$store.direct.state.admin.transcodingregions
    },
    regionKeys (): string[] {
      const keys = Object.keys(this.regions)
      keys.sort()
      return keys
    },
    wowzaStats (): KeyDict<WowzaStat> {
      return this.$store.direct.state.opsmonitor.wowzastats
    },
    unUsedServers (): KeyDict<WRTCServer> {
      const existingServers: string[] = []
      Object.values(this.regions).forEach(region => {
        Object.keys(region.wrtcserver).forEach(key => { existingServers.push(key)})
      })
      const servers: KeyDict<WRTCServer> = {}
      Object.keys(this.wowzaStats).forEach(serverid => {
        if (!existingServers.includes(serverid)) {
          servers[serverid] = new WRTCServer({ url: `wrtc-${serverid}.kiswe.com` })
        }
      })
      return servers
    },
    iOSsettings (): IOSSettings {
      return this.$store.direct.state.admin.iOS
    }
  },
  methods: {
    updateIOSSettings () {
      const state = this.iOSsettings.enabled ? 'disable' : 'enable'
      this.$confirm(`Are you sure to ${state} iOS devices?`, `${state} iOS devices`).then(async () => {
        await this.$store.direct.dispatch.admin.updateIOSEnabled(!this.iOSsettings.enabled)
        this.$message(`iOS devices are now ${state}d`)
      }).catch(_ => {})
    },
    clearCache () {
      this.$confirm('Are you sure to clear the loadbalancer cache, all thumbnails that are currently running on ' +
                    'a disabled wowza server will go down for a minute', 'Clear Cache').then(async () => {
        await this.$store.direct.dispatch.admin.clearTranscodingLoadbalancerCache()
        this.$message('Cache cleared')
      }).catch(_ => {})
    }
  },
  components: {
    LeftSidebarLayout,
    RegionSummary,
    WRTCServerSummary,
    GlobalAcceleratorOverview,
    'el-checkbox-button': CheckboxButton,
    'el-button': Button
  }
})
